import { cn } from '@/utils/cn';
import { isRedirectModeRequested } from '@/utils/checkoutMode';

interface Props {
  children: React.ReactNode;
}

export const Modal = ({ children }: Props) => {
  // In redirect mode the checkout owns the whole tab, so there is no store
  // behind it to dim — the card sits on a plain white page and reads as depth
  // through a soft shadow instead of contrast against a scrim. Phones render
  // the card edge-to-edge in both modes, so the radius and shadow stay `sm:`.
  const isRedirectMode = isRedirectModeRequested();

  return (
    <div
      data-testid="checkout-modal"
      className={cn(
        'fixed inset-0 z-50',
        isRedirectMode ? 'bg-white' : 'bg-black/50',
        // Lets `.checkout-boot-stage--loading`'s scrim-fade-in animation
        // (global.css) know there is no scrim to fade in here — see the
        // matching override there.
        isRedirectMode && 'checkout-modal--redirect',
        'sm:p-6',
        'flex items-center justify-center',
        'landscape:p-0'
      )}
    >
      <div
        data-testid="checkout-modal-content"
        className={cn(
          'bg-white',
          isRedirectMode ? 'sm:rounded-[20px]' : 'sm:rounded-xl',
          'w-full h-full md:max-w-[976px] md:max-h-[871px]',
          'sm:w-[90vw] sm:h-[90vh]',
          'transform transition-all duration-300',
          'md:overflow-y-auto',
          'relative',
          isRedirectMode ? 'sm:shadow-[0_0_15px_rgba(0,0,0,0.1)]' : 'sm:shadow-2xl sm:shadow-gray-900/20',
          'flex flex-col',
          'landscape:w-full landscape:h-[100dvh] landscape:max-w-full landscape:max-h-full',
          'landscape:rounded-none landscape:shadow-none landscape:border-0 landscape:overflow-hidden'
        )}
      >
        {children}
      </div>
    </div>
  );
};
